// extracted by css-extract-rspack-plugin
export default {"badge":"FavoriteFlagButton_badge__E6po2","flagged":"FavoriteFlagButton_flagged__aH7as"};